// extracted by mini-css-extract-plugin
export default {"imageContainer":"sba-z","summaryPar":"tba-z","ratingCategories":"uba-z","reviewerInfo":"vba-z","reviewTypes":"wba-z","expanded":"xba-z"};